app.controller('CIFTakenAJA-CTRL', function ($scope, $routeParams, $rootScope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $translate) {
    $scope.user = {
        Email: '',
    };

    $scope.printXyz = function () {
        console.log($scope.user);
        console.log('CODE', $scope.user.code1);
        console.log('EMAIL', $scope.user.Email);
    }

    if ($routeParams.generatedconfirmation) {
        $scope.user.generatedconfirmation = $routeParams.generatedconfirmation;
    }
    else {
        $window.location.href = "#/register";
        $window.location.reload();
    }

    var allPromise = $q.all([
         $http({
             method: 'GET',
             url: 'service/client.svc/recheckConfirmationLink?key=' + window.location.href.substr(window.location.href.lastIndexOf('/') + 1),
         }).then(function (data) {
             $scope.result = data.data.d;
             console.log("result", $scope.result);
            
         }, function (error) { }),



    ]);


    $scope.submit = function () {
        $scope.user.OTP = $scope.user.code1 + $scope.user.code2 + $scope.user.code3 + $scope.user.code4;
        console.log('user', $scope.user);
        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/AktivasiUser',
                        data: {
                            User: $scope.user
                        }
                    }).then(function (data) {

                        if (data.data.d.result) {
                            swal('Activation Success', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/login";
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed, Check OTP in Email', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    }


    allPromise.then(function () {
      
    });


   
});
